import StrengthIndicator from './StrengthIndicator'

export default StrengthIndicator

export { StrengthIndicator }
